//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  props: {
    tag: {
      type: String,
      default: () => 'div',
    },
  },

  data() {
    return {
      ignoreUtilFocusChanges: false,
      lastFocused: null,
    };
  },

  mounted() {
    document.addEventListener('focus', this.trapFocus, true);
  },

  beforeDestroy() {
    document.removeEventListener('focus', this.trapFocus, true);
  },

  methods: {
    isFocusable(element) {
      if (element.tabIndex < 0) {
        return false;
      }

      if (element.disabled) {
        return false;
      }

      switch (element.nodeName) {
        case 'A':
          return !!element.href && element.rel !== 'ignore';

        case 'INPUT':
          return element.type !== 'hidden';

        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
          return true;

        default:
          return false;
      }
    },

    attemptFocus(element) {
      if (!this.isFocusable(element)) {
        return false;
      }

      // Prevent running the focus callback
      // while we are trying to change to the right one.
      this.ignoreUtilFocusChanges = true;

      try {
        element.focus();
      } catch (e) {
        // continue regardless of error
      }

      this.ignoreUtilFocusChanges = false;

      return document.activeElement === element;
    },

    focusFirstDescendant(element) {
      for (let i = 0; i < element.childNodes.length; i++) {
        const child = element.childNodes[i];

        if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
          return true;
        }
      }

      return false;
    },

    focusLastDescendant(element) {
      for (let i = element.childNodes.length - 1; i >= 0; i--) {
        const child = element.childNodes[i];

        if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
          return true;
        }
      }

      return false;
    },

    trapFocus(evt) {
      if (this.ignoreUtilFocusChanges) {
        return;
      }

      if (this.$refs.content.contains(evt.target)) {
        this.lastFocused = evt.target;
      } else {
        this.focusFirstDescendant(this.$refs.content);

        if (this.lastFocused === document.activeElement) {
          this.focusLastDescendant(this.$refs.content);
        }

        this.lastFocused = document.activeElement;
      }
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, { tag: "component" }, [
    _c("div", { attrs: { tabindex: "0" } }),
    _vm._v(" "),
    _c("div", { ref: "content" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { attrs: { tabindex: "0" } }),
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) return;
	install.installed = true;
	Vue.component("FocusTrap", __vue_component__);
}

// Create module definition for Vue.use()
const plugin = {
	install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;

if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}

if (GlobalVue) {
	GlobalVue.use(plugin);
}

export { __vue_component__ as default, install };
